import AllowanceSummary from '@/models/reporting/AllowanceSummary'

export default class LeaveAllowanceSummary extends AllowanceSummary {}
